/**
 * 认证中间件
 * 用于保护需要登录的页面
 */
import { getToken } from '../lib/token';

export default defineNuxtRouteMiddleware(() => {
  // 只在客户端执行
  if (import.meta.server) {
    return;
  }

  // 检查是否有 token
  const token = getToken();

  if (!token) {
    // 没有 token，重定向到登录页
    return navigateTo('/login');
  }

  // 有 token，使用 useAuth 初始化用户状态
  const { initAuth, user } = useAuth();

  // 如果还没有用户信息，初始化
  if (!user.value) {
    initAuth();
  }

  // 再次检查用户信息（initAuth 可能会因为 token 无效而清除用户）
  if (!user.value) {
    return navigateTo('/login');
  }
});
